export enum UserTypes {
    Unauthenticated = "Unauthenticated",
    GlobalAdmin = "GlobalAdmin",
    PartnerAdmin = "PartnerAdmin",
    CustomerAdmin = "CustomerAdmin",
    User = "User",
}